import { z } from "zod";

export const discountSchema = () => {
  return z
    .object({
      company: z.number().min(1),
      voucher_batch: z.number().optional().nullable(),
      name: z.string().min(1),
      description: z.string().optional().nullable(),
      mode: z.string().min(1),
      type: z.string().min(1),
      discount: z.coerce.number().optional().nullable(),
      active: z.boolean(),
      coupon: z.string().optional().nullable(),
      link: z.string().optional().nullable(),
      in_all_stores: z.boolean().optional().nullable(),
      stores: z.array(z.number()).optional().nullable(),
      limited_codes: z.boolean().optional().nullable(),
      original_price: z.string().optional().nullable(),
      buy_price: z.string().optional().nullable(),
      sale_price: z.string().optional().nullable(),
      pop_up: z.boolean().optional().nullable(),
      featured: z.boolean().optional().nullable(),
      rules: z.string().optional().nullable(),
      how_to_use: z.string().optional().nullable(),
      image: z.any().optional().nullable(),
      start_date: z
        .union([z.string(), z.date()])
        .optional()
        .nullable()
        .transform((v) =>
          v == null || v === "" || (typeof v === "string" && !v.trim())
            ? null
            : v instanceof Date
              ? v.toISOString().split("T")[0]
              : String(v).trim()
        ),
      end_date: z
        .union([z.string(), z.date()])
        .optional()
        .nullable()
        .transform((v) =>
          v == null || v === "" || (typeof v === "string" && !v.trim())
            ? null
            : v instanceof Date
              ? v.toISOString().split("T")[0]
              : String(v).trim()
        ),
    })
    .superRefine((data, ctx) => {
      if (data.mode === "online" && !data.link) {
        ctx.addIssue({
          path: ["link"],
          code: z.ZodIssueCode.custom,
          message:
            "O campo 'link' deve ser um link HTTP válido se o modo for 'online'.",
        });
      }
      if (
        data.mode === "online" &&
        data.link &&
        !data.link.startsWith("http")
      ) {
        ctx.addIssue({
          path: ["link"],
          code: z.ZodIssueCode.custom,
          message:
            "O campo 'link' deve ser um link HTTP válido se o modo for 'online'.",
        });
      }
      if (data.type === "discount" && (data.discount === null || data.discount === undefined)) {
        ctx.addIssue({
          path: ["discount"],
          code: z.ZodIssueCode.custom,
          message: "O campo 'discount' deve ser informado quando o tipo for 'discount'.",
        });
      }

      if (data.mode === "local" && !data.in_all_stores) {
        const hasStores = Array.isArray(data.stores) && data.stores.length > 0;
        if (!hasStores) {
          ctx.addIssue({
            path: ["stores"],
            code: z.ZodIssueCode.custom,
            message: "Selecione pelo menos uma loja quando não estiver em todas as lojas.",
          });
        }
      }

      // Validação de período: start_date não pode ser maior que end_date
      if (data.start_date && data.end_date) {
        const start = new Date(data.start_date);
        const end = new Date(data.end_date);

        if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && start > end) {
          ctx.addIssue({
            path: ["end_date"],
            code: z.ZodIssueCode.custom,
            message: "A data final deve ser maior ou igual à data de início.",
          });
        }
      }
    });
};

export type DiscountFormValues = z.infer<ReturnType<typeof discountSchema>>;
